import { SiteContainer } from '../SiteUi';

const FILIAIS = [
  { name: 'Florianópolis', value: 'R$ 180 mil', os: '42 OS' },
  { name: 'Palhoça', value: 'R$ 97 mil', os: '21 OS' },
  { name: 'São José', value: 'R$ 151 mil', os: '33 OS' },
];

export function SiteNetwork() {
  return (
    <section className="border-y border-[#d9d4cc] bg-white py-20 sm:py-28">
      <SiteContainer>
        <p className="text-center text-xs tracking-[0.28em] text-[#5c5852]">SUA REDE</p>
        <h2 className="mx-auto mt-4 max-w-[16ch] text-center font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          Uma operação por filial. Uma visão para quem administra a rede.
        </h2>

        <div className="mx-auto mt-14 max-w-3xl">
          <div className="border border-[#d9d4cc] bg-white px-6 py-8 text-center">
            <p className="text-sm text-[#5c5852]">Matriz</p>
            <p className="mt-2 font-os text-3xl text-[#16181d]">R$ 428.190/mês</p>
            <p className="mt-1 text-sm text-[#5c5852]">96 OS · 3 filiais</p>
          </div>
          <div className="mx-auto h-10 w-px bg-[#d9d4cc]" aria-hidden />
          <div className="grid gap-4 sm:grid-cols-3">
            {FILIAIS.map((filial) => (
              <article key={filial.name} className="border border-[#d9d4cc] bg-[var(--site-paper)] p-5">
                <p className="font-display text-lg font-semibold text-[#16181d]">{filial.name}</p>
                <p className="mt-2 font-os text-sm text-[#16181d]">{filial.value}</p>
                <p className="mt-1 text-xs text-[#5c5852]">{filial.os} · estoque · caixa</p>
              </article>
            ))}
          </div>
        </div>
      </SiteContainer>
    </section>
  );
}
